var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.309326,
    y: 0.988281,
    width: 28.866,
    height: 30.3371,
    fill: "url(#pattern0_110_373)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_110_373",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_110_373",
    transform: "matrix(0.0111111 0 0 0.0105723 0 0.0242459)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_110_373",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADUElEQVR4nO3cO08UURjG8aOlFkoBCqKlH0AN1jbaKZDYGgoLE28YCwsKqcCPIGIksTJGYkG0UKMWRluovEVjB3grgHhL9G9OfDesXPccdmbO7D6/crM7855nZ2ZnZ868zomIiIiIiIiISF0AbcB+oBs4BwwDo8A48ASYAt4BM8BXYI5Fc/bajL1nyj4zbssYtmV22zraGvZrA1qAg0AfMAiMAY+A18B38ufX+cpqGLOa+qzGFpc6oAM4AlwERoCnwCzlM2u1j9hY/Jg6it7lTwG3ShpoqI92SPKHovY8At5h33YRu30qfgA3Mgsc6AE+FT3KhHwGeusd8kngd9EjS9Af4HQ9t2S/QFmZz6ZnoyHvtnNVWdsXYNdGgvbnmlKb0diQ9wC/alyJwE+gMyboC0ov2NmYoO+Hr6fpTcQE/b7pYwv3NibohYgVNbuFmKAlgoLOiYLOiYLOSZmCHijzD3FpgnaLd2xGynjFsFRBV9hN1WeUiAuVSqHAJuA48IESKG3QFcAW4BIwT8JcqFQLBTqBm6nejGiYoCuALuA5iXGhylAo/47fJ4BpEtGQQVcAW23WUeHTIFyo0hS6/B6nP34XxoUqTaErAA4Bk6Wov4giowpdvf7NdvzOdcpa0wVdAWwHrthUrvTqz6OouhRa+3j2ArfJWExhhXDZBj2RXP1ZF7SaDALWoWMldQxYP4ZrqePpnX+mJXcxxRbCbSxgP41Nf1hqERmw/oKHcmEB66JSLBd2mfQFiYnZHZMsFF34zzZodCurvtzygHVzNgvu/5APaLpBRpwm0ORmQFPCpHFO78pOQedEQSccdGnnKBdoLiZo36dIwryJCfpe4EqEuAc6zyu5YGdip1fpofusH7q3sH3vIMmyjUTVpG/f9EPW768U3xjFwu5NdXZ9w7T6qQpbzauybl61ZMv2u4hk1Y6tKux24HpeMzObssHgksB3+nNGayPZLC0z7+bWMnOdLf0w0A9ctfbCyTzAE8DX/NjG0G9jKi7YwJmcXTbzftB2uYfWWvgb+fPrfAk8sFouW22+xm2uUQGtwD7gmO2WQ8A14I5tWZVG3dPW6LD6qdl5e23a3jNpn7ljD+wP2TKP2jpaix6viIiIiIiIiIhrEH8BelVYxPQ3ygQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.b25eb330a23004ef61141f4005fd709c.svg";
export { ForwardRef as ReactComponent };